import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFilter = ({ title, titleId, ...props }) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M17 10.25C18.7956 10.25 20.25 8.79563 20.25 7C20.25 5.20437 18.7956 3.75 17 3.75C15.2044 3.75 13.75 5.20437 13.75 7C13.75 8.79563 15.2044 10.25 17 10.25Z",
			stroke: "currentcolor",
			strokeWidth: 1.5,
			strokeLinecap: "square"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M9 20.25C10.7956 20.25 12.25 18.7956 12.25 17C12.25 15.2044 10.7956 13.75 9 13.75C7.20438 13.75 5.75 15.2044 5.75 17C5.75 18.7956 7.20438 20.25 9 20.25Z",
			stroke: "currentcolor",
			strokeWidth: 1.5,
			strokeLinecap: "square"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M13.5 7H3.75",
			stroke: "currentcolor",
			strokeWidth: 1.5,
			strokeLinecap: "square"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M5.5 17H3.75",
			stroke: "currentcolor",
			strokeWidth: 1.5,
			strokeLinecap: "square"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M20.25 17H12.5",
			stroke: "currentcolor",
			strokeWidth: 1.5,
			strokeLinecap: "square"
		})
	]
});
export default SvgFilter;
